<template>
    <b-tab title-link-class="p-0">
        <template v-slot:title>
            <b-nav-item-dropdown>
                <template slot="button-content">
                    <i class="famfamfam-silk cus-bell"></i>
                    Tasks
                </template>
                <b-dropdown-item href="#0" @click="loadList(0)">
                    <i class="cus-bell"></i>Open
                </b-dropdown-item>
                <b-dropdown-item href="#0" @click="loadList(2)">
                    <i class="cus-cog"></i>In Progress
                </b-dropdown-item>
                <b-dropdown-item href="#0" @click="loadList(1)">
                    <i class="cus-accept"></i>Complete
                </b-dropdown-item>
                <div class="dropdown-divider"></div>
                <b-dropdown-item @click.stop="showAddTaskModal()">
                    <i class="cus-add"></i> New Task
                </b-dropdown-item>
            </b-nav-item-dropdown>
        </template>
        <b-card-text>
            <list-tasks
                :key="componentKey"
                :status="status"
                module="patient"
                @edit="triggerEdit"
                @reassign="triggerReassign"
                :patientId="patientId"
            />

            <modal-update-task
                @reload="loadList()"
                ref="modalEditTask"
                module="patient"
                :is-edit="true"
                :current-client="$store.state.client.client_details"
                :patientDetails="patientDetails"
            />

            <modal-update-task
                @reload="loadList()"
                ref="modalReassignTask"
                module="patient"
                :is-reassign="true"
                :current-client="$store.state.client.client_details"
                :patientDetails="patientDetails"
            />
        </b-card-text>
    </b-tab>
</template>
<script>
export default {
    components: {
        ListTasks: () => import("@/components/tasks/task-list"),
        ModalUpdateTask: () => import("@/components/tasks/task-update-modal")
    },
    props: {
        patientDetails: {
            type: Object
        }
    },
    data() {
        return {
            componentKey: 0,
            isEdit: false,
            isReassign: false,
            status: 0
        };
    },
    computed: {
        patientId() {
            return this.patientDetails ? this.patientDetails.id : null;
        },
        statusActive() {
            return this.$store.getters["patient/statusActive"];
        }
    },
    mounted() {},
    methods: {
        loadList(status, useCurrentStatus = false) {
            if(useCurrentStatus){
                status = this.status
            }

            this.status = status;
            this.componentKey += 1;
        },
        showAddTaskModal() {
            this.$parent.$parent.$refs.modalAddNewTask.open();
        },
        async triggerEdit(task) {
            this.$store.dispatch("task/getTaskDetails", task.id).then(() => {
                this.$refs.modalEditTask.open();
            });
        },
        async triggerReassign(task) {
            this.$store.dispatch("task/getTaskDetails", task.id).then(() => {
                this.$refs.modalReassignTask.open();
            });
        }
    }
};
</script>
